import React, { useContext, useEffect } from "react";
import { useHistory } from "react-router-dom";
import PropTypes from "prop-types";
import ErrorOutlineOutlinedIcon from "@material-ui/icons/ErrorOutlineOutlined";
import { UserContext } from "../../context/UserContext";
import "./error-redirect.scss";
import _ from "lodash";

const ErrorRedirect = (props) => {
  const { error } = props;
  const { _setIsLoading } = useContext(UserContext);
  const history = useHistory();

  // This is error we get from OKTA
  useEffect(() => {
    if (error.message) {
      _setIsLoading(false);
    }
    // Below condition  is to handle the special case when OKTA gives error after session is timeout.
    if (error.errorCode === "INTERNAL" && error.message === "Could not load PKCE codeVerifier from storage") {
      history.push("/");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (error.redirect) {
      history.push(error.redirectPath != null ? error.redirectPath : "/");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error.redirect]);

  return (error.message && error.errorCode === "access_denied" && !error.redirect) ? (
    <div className="errorContainer">
      <div className="errorHeading">{_.get(error, "type") === "restricted" ? "Access denied" : "Login failed"}</div>
      <div className="errorContent">
        <ErrorOutlineOutlinedIcon className="icon" /> {_.includes(error.message,"client",false)?"User is not assigned a role.":error.message}{" "}
        {_.get(error, "type") === "restricted" ? (
          ""
        ) : (
          <span>
            <div>
              To access MORPh, please email {" "}
              <a style={{ color: "#6B91DB" }} href={"mailto: MTODigitalAssetHelp@warnermedia.com"}>
                {"MTODigitalAssetHelp@warnermedia.com"}
              </a> with the following :
            </div>
            <div className="errorMessage">
              <ol>
                <li>First and Last Name</li>
                <li>Email Address</li>
                <li>Existing MORPh user on your team (for mirroring permissions)</li>
              </ol>
            </div>
          </span>
        )}
      </div>
    </div>
  ) : null;
};

ErrorRedirect.propTypes = {
  error: PropTypes.shape(),
};

ErrorRedirect.defaultProps = {
  error: null,
};

export default ErrorRedirect;